// CUSTOMIZED BLOCKS IMPORTS
import customBlocks from 'volto-deba/components/Blocks/customBlocks';
import reducers from './reducers';
import OstatuaJatetxeaView from './components/Views/OstatuaJatetxeaView';
const restrictedBlocks = [
  'dataqueryfilter',
  'data_connected_embed',
  'custom_connected_block',
  'dottedTableChart',
  'simpleDataConnectedTable',
  'conditionalDataBlock',
  'countryFlag',
  'metadata',
  'metadataSection',
  'html',
];

const applyConfig = (config) => {
  config.blocks = {
    ...config.blocks,
    blocksConfig: { ...customBlocks(config, restrictedBlocks) },
  };
  config.addonReducers = {
    ...config.addonReducers,

    ...reducers,
  };
  config.views.contentTypesViews['Ostatua'] = OstatuaJatetxeaView;
  config.views.contentTypesViews['Jatetxea'] = OstatuaJatetxeaView;
  config.settings = {
    ...config.settings,
    nonContentRoutes: [...config.settings.nonContentRoutes],
    isMultilingual: true,
    navDepth: 2,
    supportedLanguages: ['eu', 'es', 'en', 'fr'],
    defaultLanguage: 'eu',
    pluggableStylesBlocksBlacklist: restrictedBlocks,

    registry: {
      ...config.settings.registry,
    },
    externalRoutes: [{ match: '/fitxategiak' }],
    showTags: false,
    pictureOptions: {
      grid: [
        { media: '(min-width: 768px)', image: 'preview' },
        { media: '(max-width: 767px)', image: 'large' },
      ],
      newsitem: [
        { media: '(min-width: 1200px)', image: 'larger' },
        { media: '(min-width: 992px) and (max-width: 1199px)', image: 'large' },
        { media: '(max-width: 991px)', image: 'teaser' },
      ],
    },
  };
  return config;
};

export default applyConfig;
